module.exports = __webpack_public_path__ + "static/media/eye-on.3d12ff76.png";